























































import Vue from 'vue'
import DatePicker from './Pickers/DatePicker.vue'
import moment from 'moment'
// Types
import { DateAndType, Range } from './types'
import { apiDropdownsTargetGroups } from '@/api'

export default Vue.extend({
  name: 'SearchToolbar',
  components: { DatePicker },
  data: () => ({
    items: [
      'day',
      'week',
      'month',
      'custom'
    ],
    type: 'day',
    range: {},
    target: null,
    targets: []
  }),
  methods: {
    calculateRange (v: DateAndType): Range {
      this.range = v
      switch (v.type) {
        case 'day':
          return {
            from: v.value,
            till: moment(v.value).add(1, 'days').format('YYYY-MM-DD')
          }
        case 'month':
          return this.mkMonthDate(v)
        case 'week':
        case 'custom':
          return {
            from: v.value[0],
            till: v.value[1]
          }
      }
    },
    mkMonthDate (v: DateAndType): Range {
      const [year, month]: string[] = v.value.split('-')
      const amountOfDays = new Date(Number(year), Number(month), 0).getDate()
      return {
        from: `${month}-01-${year}`,
        till: `${month}-${amountOfDays}-${year}`
      }
    },
    getTrips (v: DateAndType): void {
      const range = this.calculateRange(v)
      const target = this.target
      this.$emit('getTrips', {
        range,
        target
      })
    }
  },
  mounted (): void {
    this.type = 'week'
    apiDropdownsTargetGroups()
      .then((response: any) => {
        this.targets = response?.data?.data
      })
  }
})
